export { default } from './SectionVideo';